import PageLayout from '../components/layout/PageLayout';
import Seo from '../components/Seo';
import './SystemRequirementsPage.css';

export default function SystemRequirementsPage() {
  return (
    <PageLayout title="Минимальные системные требования Recvisit">
      <Seo
        title="Минимальные системные требования Recvisit"
        description="Подробные требования к устройству-сканеру, административной панели и смартфону сотрудника для стабильной работы SaaS-сервиса Recvisit."
        canonicalPath="/system-requirements"
      />
      <div className="container">
        <p className="sr-lead">
          Ниже приведены минимальные системные требования для стабильной работы Recvisit. Мы рекомендуем ориентироваться
          на них при выборе устройств, чтобы обеспечить уверенное сканирование QR‑кодов и корректную синхронизацию данных
          в SaaS‑сервисе.
        </p>

        <div className="sr-grid">
          <section className="sr-card">
            <h2 className="sr-h2">Устройство‑сканер (планшет/смартфон)</h2>
            <ul className="sr-list">
              <li><strong>Фронтальная камера:</strong> не менее 15 МП (рекомендуется 20 МП и выше)</li>
              <li><strong>Возраст устройства:</strong> не старше 5 лет</li>
              <li><strong>ОС:</strong> Android 10+ (API 29+) или iOS 13+</li>
              <li><strong>Браузер:</strong> Chrome (последние версии, обязательно) для Android, Safari для iOS</li>
              <li><strong>Интернет:</strong> стабильное подключение (Wi‑Fi / 4G / 5G)</li>
              <li><strong>Рекомендуемо:</strong> автофокус, достаточное освещение зоны сканирования</li>
            </ul>

            <div className="sr-note">
              <div className="sr-note-title">Протестировано (стабильно)</div>
              <ul className="sr-note-list">
                <li>Poco F3</li>
                <li>Realme 14T</li>
              </ul>
            </div>
          </section>

          <section className="sr-card">
            <h2 className="sr-h2">Административная панель (ПК/ноутбук)</h2>
            <ul className="sr-list">
              <li><strong>Браузер:</strong> актуальные версии Chrome / Edge / Firefox / Safari</li>
              <li><strong>Интернет:</strong> стабильное подключение</li>
              <li><strong>Экран:</strong> рекомендуется 1280×720 и выше</li>
              <li><strong>Настройки:</strong> включён JavaScript, разрешены cookies (для авторизации)</li>
            </ul>
          </section>

          <section className="sr-card">
            <h2 className="sr-h2">Смартфон сотрудника (PWA)</h2>
            <ul className="sr-list">
              <li><strong>Возраст устройства:</strong> не старше 5 лет</li>
              <li><strong>ОС:</strong> Android 10+ (API 29+) или iOS 13+</li>
              <li><strong>Браузер:</strong> Chrome (последние версии, обязательно) для Android, Safari (обязательно) для iOS</li>
              <li><strong>Интернет:</strong> подключение к сети</li>
              <li><strong>Формат приложения:</strong> PWA (Progressive Web App) — устанавливается через браузер, не требует магазина приложений</li>
            </ul>
          </section>
        </div>

        <section className="sr-disclaimer" aria-label="Правовая оговорка">
          <h2 className="sr-h2">Правовая оговорка</h2>
          <p>
            Изображения планшетов, смартфонов и иных устройств, размещённые на сайте Recvisit, являются исключительно
            иллюстративными примерами и предназначены для демонстрации возможностей сервиса. Указанные изображения не
            являются рекомендацией к использованию конкретных моделей устройств, производителей или брендов.
          </p>
          <p>
            Сервис Recvisit совместим с широким спектром устройств при условии соответствия минимальным системным
            требованиям, указанным на данной странице. Выбор конкретного устройства осуществляется Пользователем
            самостоятельно.
          </p>
          <p>
            Индивидуальный предприниматель Шмелева Екатерина Владимировна не несёт ответственности за функциональность,
            качество либо производительность устройств, выбранных Пользователем. Рекомендуется провести тестирование
            выбранного устройства перед началом использования сервиса.
          </p>
        </section>
      </div>
    </PageLayout>
  );
}

